import AboutCompanyForm from "./about-company-form";

export default AboutCompanyForm;